import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { PenaltyGetActionTypes, PenaltyPayActionTypes } from './types';
import { getPenaltyActions, payPenaltyActions } from './actions';
import OffenceService from '../../services/offence.service';
import PayPenaltyRequest from '../../models/penalty/PayPenaltyRequest';
import RedirectPenaltyRequest from "../../models/order/RedirectPenaltyRequest";
import OrderService from '../../services/order.service';
import OrderResponse from '../../models/order/OrderResponse';
import { ResponseCode } from '../../models/order/ResponseCode';
import Toast from '../../components/shared/Toast';
import CorvusUtility from '../../blocks/utils/corvus-utility';
import I18n from '../../blocks/localization';

export default function* penaltySaga() {
    yield takeEvery(PenaltyGetActionTypes.REQUEST, getPenaltyRequest);
    yield takeEvery(PenaltyGetActionTypes.ERROR, getPenaltyError);
    yield takeEvery(PenaltyPayActionTypes.REQUEST, payPenaltyRequest);
    yield takeEvery(PenaltyPayActionTypes.SUCCESS, payPenaltySuccess);
    yield takeEvery(PenaltyPayActionTypes.ERROR, payPenaltyError);
}

function* getPenaltyRequest(action: Action<any>) {
    yield sagaUtility(action.payload, OffenceService.getPenalty, getPenaltyActions.success, getPenaltyActions.failure);
}

function* getPenaltyError(action: Action<any>) {
    if (action.payload.errorMessage) {
        Toast.notifyError(action.payload.errorMessage);
    } else {
        Toast.notifyError(I18n.t('penaltyPay.penaltyGetError'));
    }
}

function* payPenaltyRequest(action: Action<PayPenaltyRequest>) {
    const payPenaltyRequest = action.payload;
    const redirectRequest = {
        penaltyReferenceNumber: payPenaltyRequest.penaltyNumber,
        penaltyAmount: payPenaltyRequest.penaltyAmount,
        buyerEmail: payPenaltyRequest.email
    } as RedirectPenaltyRequest;

    yield sagaUtility(redirectRequest, OrderService.redirectPenalty, payPenaltyActions.success, payPenaltyActions.failure);
}

function* payPenaltySuccess(action: Action<any>) {
    const orderResponse = action.payload as OrderResponse;

    if (orderResponse?.ResponseCode === ResponseCode.Error) {
        Toast.notifyError(orderResponse.ResponseMessage);
    }
    else {
        CorvusUtility.redirectToPaymentForm(action.payload);
    }
}

function* payPenaltyError(action: Action<OrderResponse>) {
    Toast.notifyError(action.payload.ResponseMessage);
}
